/** @format */
import angular from 'angular';
import { MyPlanSelectComponent } from '../common/components/my-plan-select/my-plan-select.component.ts';
import plansTpl from './plans.tpl.html';
export const plansModule = 'student.tutoring.plans';
angular.module(plansModule, ['sis-components.date.localDateFormatFilter', MyPlanSelectComponent.downgrade.moduleName]).component('plans', {
  template: plansTpl,
  controller: ["$state", function ($state) {
    this.state = $state;
  }],
  bindings: {
    plans: '<',
    selectedPlan: '<'
  }
});